const ISO_DATETIME = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2})(?:[.,](\d+))?)?(Z|[+-]\d{2}(?::?\d{2})?)?$/i

/**
 * Время сервера в микросекундах от эпохи или null.
 * DRF отдаёт микросекунды и смещение (`2026-10-29T15:00:00.123456+03:00`):
 * Date.parse режет их до миллисекунд и не во всех WebView понимает такой формат,
 * а для сравнения updated_at нужна полная точность.
 */
export function parseServerTimestamp(value) {
  if (typeof value !== 'string') {
    return null
  }

  const match = ISO_DATETIME.exec(value.trim())
  if (!match) {
    return null
  }

  const [, year, month, day, hours, minutes, seconds = '0', fraction = '', zone = 'Z'] = match
  let ms = Date.UTC(+year, +month - 1, +day, +hours, +minutes, +seconds)

  if (zone.toUpperCase() !== 'Z') {
    const sign = zone[0] === '-' ? -1 : 1
    const digits = zone.slice(1).replace(':', '')
    const offsetMinutes = Number(digits.slice(0, 2)) * 60 + Number(digits.slice(2, 4) || 0)
    ms -= sign * offsetMinutes * 60_000
  }

  return ms * 1000 + Number(fraction.slice(0, 6).padEnd(6, '0'))
}

/** <0, 0, >0 как у сортировки; null, если одно из значений не разобрать. */
export function compareServerTimestamps(a, b) {
  const left = parseServerTimestamp(a)
  const right = parseServerTimestamp(b)

  if (left == null || right == null) {
    return null
  }

  return left - right
}
